export const columnsDataFaqOverview = [
    {
        Header: 'SR',
        accessor: 'sr',
    },
/*    {
        Header: 'CATEGORY',
        accessor: 'category'
    },*/
    {
        Header: 'QUESTION',
        accessor: 'question',
    },
    {
        Header: 'ANSWER',
        accessor: 'answer',
    }
];
